import type from './CARELABEL.type';

const initialState = {
  productDetails: {},
  comment: '',
  commentSwitch: false,
  isVisibleToSupplier: [],
  CareProductList: [],
  CareLibraryList: [],
  CareGroupList: [],
  isComplete: false,
  ProductDropDownList: [],
  ProductAsyncList: [],
  layoutCareData: [],
  careList: [],
  careGroupList: [],
  productList: [],
  careLibrariesData: {},
  productCareList: {},
};

const CareLabelConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: action.payload,
      };

    case type.FETCH_ORDER_PERMISSION_CARELABEL:
      let updateData = JSON.parse(JSON.stringify(state));
      if (action.payload && Object.keys(action.payload).length > 0) {
        const comment = action.payload.comment ? action.payload.comment : '';
        const commentSwitch = action?.payload?.isVisibleToSupplier?.comment ? action.payload.isVisibleToSupplier.comment : false;
        const visibleToSupplier = action.payload.isVisibleToSupplier ? action.payload.isVisibleToSupplier : [];
        const isComplete = action?.payload?.isComplete;
        updateData = {
          ...state,
          comment,
          commentSwitch,
          isVisibleToSupplier: visibleToSupplier,
          isComplete,
        };
      }
      return { ...updateData, isComplete: updateData?.isComplete };
    case type.UPDATE_CARE_LABEL_SWITCHES:
      return {
        ...state,
        isVisibleToSupplier: action.payload,
      };
    case type.GET_ALL_CARELABEL:
      return {
        ...state,
        CareProductList: action.payload,
      };
    case type.GET_ALL_CARE_INSTRUCTION:
      return {
        ...state,
        careList: action.payload,
      };

    case type.UPDATE_CARE_LABEL_MARK_COMPLETE:
      return {
        ...state,
        isComplete: action.payload,
      };
    case type.GET_CARELABEL_LIBRARY:
      return {
        ...state,
        CareLibraryList: action.payload,
      };
    case type.GET_CARELABEL_GROUP:
      return {
        ...state,
        CareGroupList: action.payload,
      };
    case type.GET_CARELABEL_PRODUCT_lIST:
      return {
        ...state,
        ProductDropDownList: action.payload,
      };
    case type.GET_CARE_LABEL_PRODUCT_DATA:
      return {
        ...state,
        ProductAsyncList: action.payload,
      };
    case type.GET_CARE_LAYOUT_DATA:
      return {
        ...state,
        layoutCareData: action.payload,
      };
    case type.GET_ALL_CARE_GROUP:
      return {
        ...state,
        careGroupList: action.payload,
      };
    case type.GET_PRODUCT_LIST:
      return {
        ...state,
        productList: action.payload,
      };
    case type.GET_CARE_LIBRARIES_DATA:
      return {
        ...state,
        careLibrariesData: action.payload,
      };
    case type.CLEAR_CARE_LABEL_REDUCER:
      return {
        ...state,
        comment: '',
        commentSwitch: false,
        isVisibleToSupplier: [],
      };
    case type.GET_PRODUCT_USER_INSTRUCTION_DETAILS:
      return {
        ...state,
        productCareList: action.payload,
      };

    default:
      return state;
  }
};

export default CareLabelConfigReducer;
